module.exports = __webpack_public_path__ + "img/cambio.2edfc0fc.svg";